import React from "react";
import HomePageNewsSkeleton from "../News/HomePageNewsSkeleton";

const NewsSectionSkeleton: React.FC = () => {
  return (
    <div>
      <div className="flex items-end flex-col gap-4 max-md:py-6 py-12 max-lg:text-start max-sm:text-center max-lg:px-4">
        <div className="skeleton w-[200px] h-10"></div>
        <div className="skeleton w-[320px] h-10"></div>
        <div className="mt-4 w-[246px] h-[72px]"></div>
      </div>
      <HomePageNewsSkeleton />
    </div>
  );
};

export default NewsSectionSkeleton;
